import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Skeleton } from '@/components/ui/Skeleton';

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

const stagger = {
  animate: { transition: { staggerChildren: 0.05 } },
};

export function Categories() {
  const { data, isLoading } = useQuery({
    queryKey: ['categories'],
    queryFn: () => api.categories.getAll(),
  });

  const categories = data?.data || [];

  return (
    <motion.div initial="initial" animate="animate" className="max-w-6xl mx-auto px-4 py-12">
      <motion.div variants={fadeUp}>
        <h1 className="text-4xl font-bold mb-2">Categories</h1>
        <p className="text-surface-500 mb-8">Browse quotes by category</p>
      </motion.div>

      {isLoading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={i} className="h-24 rounded-3xl" />
          ))}
        </div>
      ) : (
        <motion.div variants={stagger} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat: any) => (
            <motion.div key={cat.slug} variants={fadeUp}>
              <Link to={`/category/${cat.slug}`}>
                <motion.div
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                  className="glass-card p-6 text-center cursor-pointer h-full"
                >
                  <p className="text-xl font-bold mb-1">{cat.name}</p>
                  <p className="text-sm text-surface-500">{cat.quote_count || 0} quotes</p>
                </motion.div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      )}
    </motion.div>
  );
}
